import { Box, Switch, Typography } from '@material-ui/core';
import React from 'react';
import { useCampfireLazyQuery } from '../../../../../global/network/useCampfireLazyQuery';
import { useSnackbar } from '../../../../../global/config/useSnackbar';
import { useCampfireFetch } from '../../../../../global/network/useCampfireFetch';
import { useApiUrl } from '../../../../../global/config/useApiUrl';
import { GET_CONFIG_ITEM } from './config-item.gql';
import { GetConfigItem } from './__generated__/GetConfigItem';

export function SeeRosteredDatesOnly() {
  const [querySeeRosteredDatesOnly] = useCampfireLazyQuery<GetConfigItem, { key: string }>(GET_CONFIG_ITEM);
  const [seeRosteredDatesOnly, setSeeRosteredDatesOnly] = React.useState<boolean | undefined>();
  const { setSnackbar } = useSnackbar();

  React.useEffect(() => {
    querySeeRosteredDatesOnly({ variables: { key: 'see-rostered-dates-only' } }).then((response) =>
      setSeeRosteredDatesOnly(
        response.data?.vm.configItem?.defaultValue || response.data?.vm.configItem?.configItemValue?.flagValue
      )
    );
  }, []);

  const saveSeeRosteredDatesOnly = useCampfireFetch({ defer: true });

  const apiUrl = useApiUrl();
  const onSave = () => {
    saveSeeRosteredDatesOnly
      .run({
        url: `${apiUrl}/vm/admin-console/config`,
        method: 'post',
        data: {
          type: 'see-rostered-dates-only',
          value: !seeRosteredDatesOnly,
        },
      })
      .then(() => {
        setSnackbar({
          open: true,
          message: 'Successfully updated',
          variant: 'success',
        });
      });
    setSeeRosteredDatesOnly(!seeRosteredDatesOnly);
  };

  return (
    <Box mt={2}>
      <Box display='flex' alignItems={'center'}>
        <Switch
          checked={Boolean(seeRosteredDatesOnly)}
          onChange={onSave}
          color='primary'
          inputProps={{ 'aria-label': 'see rostered dates only' }}
        />
        <Box ml={1}>
          <Typography
            style={{
              fontWeight: 500,
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            See Rostered Dates Only
          </Typography>
          <Typography variant={'body2'} style={{ fontSize: '13px', color: '#808080' }}>
            {
              'Restrict volunteer visibility to only dates they are rostered on in My Elements and My Rosters pages. Activity Leaders, Program Managers, and Admins will see all dates as normal.'
            }
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
